import React from 'react';
import OrderListTable from "../../../components/OrderListTable";
import {ProductType} from "../../../../types/product";

export const BooksOrderPage = () => {
  return (
      <OrderListTable type={ProductType.BOOK}/>
  )
}
